export default "__VITE_ASSET__BdS4Vym8__"